import React, { useEffect, useRef, useState } from "react";
import servicosColaborador from "../../servicos/servicos-colaborador";
import MenuLateral from "./MenuLateral";
import Table from 'react-bootstrap/Table';
import NavMenu from "./Nav";
import { ToastContainer, toast } from 'react-toastify';
import Salvar from "../../img/svgs/Salvar";
import Form from "react-bootstrap/Form";
import servicosAtribuicao from "../../servicos/servicos-atribuicao";

const AtribuicaoDinamica = () => {
    const [colaboradores, setColaboradores] = useState([]);
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const descricao = useRef(null);

    useEffect(() => {

        function getDados() {
            servicosColaborador.listarTodos()
                .then(response => {
                    if (response.status === 200) {
                        setColaboradores(response.data);
                    }

                }).catch((error) => {
                    console.log(error);
                });
        }
        getDados();
    }, []);




    const handlePesquisa = (e) => {
        const pesquisa = e.target.value;
        let listaAtualizada = [];
        if (pesquisa !== "") {
            listaAtualizada = colaboradores.filter((item) => {
                return String(item.nome).toLowerCase().indexOf(pesquisa.toLowerCase()) !== -1;
            })
            setListaFiltrada(listaAtualizada);
        } else {
            setListaFiltrada(colaboradores);
        }

    }



    const atribuicaoMultipla = async () => {
        if (descricao.current.value) {

            for await (const colaborador of colaboradores) {
                const elementoWeb = document.querySelector(`#qtd_milhas${colaborador.id_colaborador}`);
                if (Number(elementoWeb?.value) !== 0 && elementoWeb?.value !== undefined) {
                    let obj = {
                        "id_colaborador": colaborador.id_colaborador,
                        "descricao": descricao.current?.value,
                        "data": new Date(),
                        "qtd_milhas": Number(elementoWeb?.value)
                    }

                    await servicosAtribuicao.createAtribuicaoDinamica(obj)
                        .then(response => {
                            if (response.status === 201) {
                                const elementoWeb = document.querySelector(`#qtd_milhas${obj.id_colaborador}`);
                                elementoWeb.value = 0;
                            }
                        })
                        .catch(e => {
                            console.log(e)
                            toast.error(`Erro ao tentar atribuir milhas colaborador id ${obj.id_colaborador}  ${e.response.data.message} `);
                        })
                }
            }
        }else{
            toast.warning('Por favor insira uma descrição para a atribuição')
        }
        

    }
    return <>
        <NavMenu />
        <ToastContainer />

        <div className="d-flex container">
            <div className="w-25">
                <MenuLateral />
            </div>

            <div className="w-75">
                <div className="d-flex sob-tabelas">
                    <div className="d-flex align-items-center row w-50 ms-1">
                        <span className="">Busca:</span> <input
                            className="mb-3 w-50  rounded-5"
                            type="text"
                            id="pesquisa"
                            style={{ height: 25 }}
                            onChange={handlePesquisa}
                        />
                    </div>
                    <div className="d-flex justify-content-center align-items-center w-50">

                        <h3 className="text-center subtitulo">Atribuição Dinâmica</h3>

                    </div>

                </div>
                <Form.Group className="mb-3" controlId="descricao">
                    <Form.Label className="label-texto">Descricão</Form.Label>
                    <Form.Control
                        className="input-cadastro"
                        type="text"
                        name="descricao"
                        ref={descricao}
                    />
                </Form.Group>
                <Table striped bordered hover responsive >
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nome</th>
                            <th >Qtd Milhas</th>
                        </tr>
                    </thead>
                    <tbody >
                        {
                            listaFiltrada.length > 0 ? (listaFiltrada.map(colaborador => (
                                <tr key={colaborador.id_colaborador} id={colaborador.id_colaborador}>
                                    <td width={50}>{colaborador.id_colaborador}</td>
                                    <td width={200}>{colaborador.nome}</td>
                                    <td style={{ width: 50 }} className="text-center">
                                        <input width={50} type="number" id={`qtd_milhas${colaborador.id_colaborador}`} className="w-75" />
                                    </td>
                                </tr>
                            ))) : (colaboradores.map(colaborador => (
                                <tr key={colaborador.id_colaborador} id={colaborador.id_colaborador}>
                                    <td width={50}>{colaborador.id_colaborador}</td>
                                    <td width={200}>{colaborador.nome}</td>
                                    <td style={{ width: 50 }} className="text-center" >
                                        <input width={50} type="number" id={`qtd_milhas${colaborador.id_colaborador}`} className="w-75 rounded-5" />
                                    </td>
                                </tr>
                            )))

                        }
                    </tbody>
                </Table>
                <button type="button" onClick={() => atribuicaoMultipla()} className="btn-icones rounded p-1"><Salvar /> Salvar</button>

            </div>
        </div>
    </>
}

export default AtribuicaoDinamica;